<div class="edit-sample-wrapper">
  @if (isLoading()) {
    <div class="flex items-center justify-center p-8">
      <p class="text-gray-500">Cargando datos...</p>
    </div>
  } @else if (sampleForm) {
    <form [formGroup]="sampleForm" class="form-content">
      <div class="section-card">
        <p class="text-sm text-gray-600 mb-4">
          Código de muestra:
          <span class="font-semibold">{{ caseNumber() }}</span>
        </p>
        <h4 class="text-sm font-thin text-gray-700 mb-6">Datos personales</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
          <app-input-text
            label="Nombres"
            [formControl]="givenNameControl"
          ></app-input-text>

          <app-input-text
            label="Segundo nombre (Opcional)"
            placeholder="Segundo nombre"
            [formControl]="middleNameControl"
          ></app-input-text>

          <app-input-text
            label="Apellidos"
            [formControl]="familyNameControl"
          ></app-input-text>

          <app-input-text
            label="Apellido materno (Opcional)"
            placeholder="Apellido materno"
            [formControl]="maternalFamilyNameControl"
          ></app-input-text>

          <app-form-dropdown
            label="Tipo de identificación"
            placeholder="Seleccione..."
            [formControl]="identifierTypeControl"
            [items]="identifierTypeDropdownOptions()"
          ></app-form-dropdown>

          <app-input-text
            label="Número de documento"
            [formControl]="idNumberControl"
          ></app-input-text>

          <app-form-dropdown
            label="Sexo"
            placeholder="Seleccione..."
            [formControl]="administrativeSexControl"
            [items]="administrativeSexDropdownOptions()"
          ></app-form-dropdown>

          <app-form-date
            label="Fecha de nacimiento"
            placeholder="Seleccione fecha"
            [formControl]="birthDateControl"
          ></app-form-date>

          <div class="md:col-span-2">
            <app-input-text
              label="Correo (Opcional)"
              placeholder="correo@ejemplo.com"
              [formControl]="emailAddressControl"
            ></app-input-text>
          </div>

          <div class="md:col-span-2">
            <div class="input">
              <label for="userDataDescription" class="input-label-item"
                >Observación de datos de usuario</label
              >
              <textarea
                id="userDataDescription"
                formControlName="userDataDescription"
                placeholder="Observación de datos de usuario"
                rows="2"
                class="input-head-item resize-none"
              ></textarea>
            </div>
          </div>

          <div class="md:col-span-2">
            <div class="input">
              <label for="clinicalHistory" class="input-label-item"
                >Resumen de historia clínica</label
              >
              <textarea
                id="clinicalHistory"
                formControlName="clinicalHistory"
                placeholder="Resumen de historia clínica"
                rows="4"
                class="input-head-item resize-none"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <h4 class="text-sm font-thin text-gray-700 mb-6">
          Datos de la muestra
        </h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
          <app-form-dropdown
            label="Ciudad de ingreso"
            placeholder="Seleccione..."
            [formControl]="regionalControl"
            [items]="regionDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Tipo de muestra"
            placeholder="Seleccione..."
            [formControl]="specimenTypeControl"
            [items]="specimenTypeDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Contenedor de muestra"
            placeholder="Seleccione..."
            [formControl]="specimenContainerIdControl"
            [items]="specimenContainerDropdownOptions()"
          ></app-form-dropdown>

          <div class="md:col-span-2">
            <div class="input">
              <label for="descriptionDataSample" class="input-label-item"
                >Observación de datos de muestra</label
              >
              <textarea
                id="descriptionDataSample"
                formControlName="descriptionDataSample"
                placeholder="Observación de datos de muestra"
                rows="2"
                class="input-head-item resize-none"
              ></textarea>
            </div>
          </div>

          <div class="md:col-span-2">
            <div class="input">
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  formControlName="consentForUseOfSamples"
                  class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                />
                <span class="text-sm font-medium text-brand-tertiary">
                  Consentimiento de uso de la información de muestra
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <h4 class="text-sm font-thin text-gray-700 mb-6">Datos del examen</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
          <app-form-dropdown
            label="Examen solicitado"
            placeholder="Seleccione..."
            [formControl]="examTypeControl"
            [items]="examTypeDropdownOptions()"
          ></app-form-dropdown>

          <div class="md:col-span-2 mt-4 mb-4">
            <div class="input">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="acmg"
                    class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                  />
                  <span class="text-sm font-medium text-brand-tertiary">
                    ¿Debe realizar ACMG?
                  </span>
                </label>

                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="mlpa"
                    class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                  />
                  <span class="text-sm font-medium text-brand-tertiary">
                    ¿Debe realizar MLPA?
                  </span>
                </label>

                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    formControlName="prioritization"
                    class="w-5 h-5 text-blue-deep border-2 border-blue-deep rounded focus:ring-2 focus:ring-blue-deep"
                  />
                  <span class="text-sm font-medium text-brand-tertiary">
                    Requiere priorización
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div class="md:col-span-2">
            <div class="input">
              <label for="descriptionDataExam" class="input-label-item"
                >Observación de datos del examen</label
              >
              <textarea
                id="descriptionDataExam"
                formControlName="descriptionDataExam"
                placeholder="Observación de datos del examen"
                rows="2"
                class="input-head-item resize-none"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <h4 class="text-sm font-thin text-gray-700 mb-6">Datos de la orden</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 mb-6">
          <app-input-text
            label="Código orden"
            placeholder="Código orden"
            [formControl]="placerOrderNumberControl"
          ></app-input-text>

          <app-form-dropdown
            label="Sede toma de muestra"
            placeholder="Seleccione..."
            [formControl]="siteControl"
            [items]="siteDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Prioridad"
            placeholder="Seleccione..."
            [formControl]="priorityIdControl"
            [items]="priorityDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Laboratorio de referencia"
            placeholder="Seleccione..."
            [formControl]="laboratoriesIdControl"
            [items]="laboratoriesDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Diagnóstico"
            placeholder="Seleccione..."
            [formControl]="diagnosesIdControl"
            [items]="diagnosesDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Especialista"
            placeholder="Seleccione..."
            [formControl]="specialistsIdControl"
            [items]="specialistsDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Compañía aseguradora"
            placeholder="Seleccione..."
            [formControl]="companyIdControl"
            [items]="companyDropdownOptions()"
          ></app-form-dropdown>

          <app-form-dropdown
            label="Proveedor"
            placeholder="Seleccione..."
            [formControl]="providerIdControl"
            [items]="providerDropdownOptions()"
          ></app-form-dropdown>
        </div>
      </div>

      <div
        class="flex justify-between gap-4 mt-8 pt-6 border-t border-gray-200"
      >
        <button
          type="button"
          (click)="onCancel()"
          class="px-6 py-3 border-2 border-blue-deep text-blue-deep rounded-lg hover:bg-blue-50 transition-colors font-medium"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="onSave()"
          [disabled]="sampleForm.invalid || isSaving()"
          class="px-6 py-3 bg-blue-deep text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
        >
          Guardar muestra
        </button>
      </div>
    </form>
  }
</div>
